var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, StyleSheet } from 'aphrodite-jss';
import bind from 'bind-decorator';
import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { CloseButton } from '@lean-body/components/atoms/close_button';
import { Colors } from '@lean-body/components/styles/variables';
export class Alert extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "keyframes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                '0%': {
                    opacity: 0,
                    transform: 'scale(0.7, 0.7)',
                },
                '100%': {
                    opacity: 1,
                    transform: 'scale(1, 1)',
                },
            }
        });
    }
    render() {
        return (React.createElement("div", { className: this.containerClass },
            React.createElement("div", { className: css(this.styles.message) }, this.props.vm.message),
            React.createElement("div", { className: css(this.styles.close) },
                React.createElement(CloseButton, { size: this.innerHeight, color: Colors.GrayDarkest, onClick: this.onClickCloseButton }))));
    }
    get containerClass() {
        return [this.props.className || '', css(this.styles.container)].join(' ');
    }
    get styles() {
        return StyleSheet.create({
            '@keyframes container': this.keyframes,
            container: {
                animationName: 'container',
                animationDuration: '0.2s',
                background: Colors.White,
                padding: '1rem 1rem',
                borderRadius: 2,
                boxShadow: '0 4px 8px rgba(0,0,0,0.07), 0 2px 2px rgba(0,0,0,0.12)',
                display: 'flex',
                flexDirection: 'row',
            },
            message: {
                color: this.isError ? Colors.Red : Colors.Black,
                flexGrow: 1,
                lineHeight: 1,
                fontSize: this.innerHeight,
            },
            close: {
                marginLeft: this.innerHeight,
            },
        });
    }
    get innerHeight() {
        return 14;
    }
    get isError() {
        return this.props.vm.isError;
    }
    onClickCloseButton() {
        this.props.vm.close();
    }
}
__decorate([
    bind
], Alert.prototype, "onClickCloseButton", null);
export class AlertVM {
    constructor(message, group, isError = false) {
        Object.defineProperty(this, "uuid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: uuidv4()
        });
        Object.defineProperty(this, "group", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lifeEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notifyKilled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.message = message;
        this.group = group;
        this.isError = isError;
        const durationSec = 5;
        this.lifeEnd = new Promise((resolve) => {
            this.notifyKilled = resolve;
        });
        setTimeout(() => {
            this.close();
        }, durationSec * 1000);
    }
    close() {
        this.notifyKilled && this.notifyKilled();
        this.notifyKilled = null;
    }
}
